import styles from './DayCard.module.css'
import ExerciseRow from '../ExerciseRow'
import { allExercises } from '../../../data/planEntrenamiento'

const DayCard = ({ day, log, onStartRest }) => {
  const { hydrated, getEntry, toggleDone, setSetValue, resetDay, lastLogged } = log
  const exercises = allExercises(day)
  const total = exercises.length
  const doneCount = hydrated
    ? exercises.filter((ex) => getEntry(day.id, ex.id).done).length
    : 0
  const complete = doneCount === total

  const renderExercise = (exercise) => (
    <ExerciseRow
      key={exercise.id}
      exercise={exercise}
      entry={getEntry(day.id, exercise.id)}
      hydrated={hydrated}
      last={hydrated ? lastLogged(day.id, exercise.id) : null}
      onToggle={() => toggleDone(day.id, exercise.id)}
      onSetValue={(i, field, value) => setSetValue(day.id, exercise.id, i, field, value)}
      onStartRest={onStartRest}
    />
  )

  return (
    <article className={`${styles.day} ${complete ? styles.complete : ''}`} id={day.id}>
      <div className={styles.head}>
        <span className={styles.tag}>{day.id}</span>
        <h3 className={styles.title}>{day.title}</h3>
        <span className={styles.meta}>{day.restNote}</span>
      </div>

      <p className={styles.strategy}>
        <b>Estrategia:</b> {day.strategy}
      </p>

      <div className={styles.tools}>
        <div className={styles.progWrap}>
          <div
            className={styles.progBar}
            style={{ width: total ? `${(doneCount / total) * 100}%` : '0%' }}
          />
        </div>
        <span className={styles.progText}>
          <b>{doneCount}</b> / {total} ejercicios
        </span>
        <button type="button" className={styles.reset} onClick={() => resetDay(day.id)}>
          Reiniciar día
        </button>
      </div>

      {complete && (
        <p className={styles.doneMsg}>
          🔥 {day.id} completado. La barra no esperó — y tú tampoco.
        </p>
      )}

      <p className={styles.warmup}>
        <b>Calentamiento:</b> {day.warmup}
      </p>

      <div className={styles.list}>{day.exercises.map(renderExercise)}</div>

      {day.core && (
        <div className={styles.core}>
          <div className={styles.coreHead}>
            <span className={styles.coreLabel}>Bloque de core · {day.core.label}</span>
            <span className={styles.coreTime}>{day.core.time}</span>
          </div>
          <p className={styles.coreNote}>{day.core.note}</p>
          <div className={styles.list}>{day.core.exercises.map(renderExercise)}</div>
        </div>
      )}

      {day.finisher && (
        <p className={styles.finisher}>
          <b>Finisher</b> — {day.finisher}
        </p>
      )}
    </article>
  )
}

export default DayCard
